<textarea #textarea>{{ initialValue }}</textarea>

<div>
  <ng-container *ngTemplateOutlet="footerTemplate(); context: footerContext()" />
</div>

<ng-content />
